// «Plan your trip»: i link di viaggio della pagina lista.
//
// VIVE QUI E NON DENTRO ListSidebar, e il motivo e' il telefono.
// Menachem, 4/11/2026: «plan your trip deve uscire dai filtri». Sul
// desktop il rail e' la colonna di sinistra e il blocco ci stava in
// fondo, il che sembrava abbastanza; ma sulla colonna stretta TUTTO il
// rail entra nel pannello «Filtri», per cui hotel, voli e noleggio
// erano letteralmente dentro la tendina dei filtri. Spostarlo in fondo
// al rail non lo tirava fuori: lo metteva in fondo alla tendina.
//
// Adesso sta SOPRA LA MAPPA, fuori dal rail, uguale sul desktop e sul
// telefono — «mettilo sopra la mappa», stesso giorno. Il punto e' quello
// giusto: viene dopo la descrizione del posto, cioe' quando uno ha appena
// letto dov'e' finito, e prima della mappa, cioe' prima di mettersi a
// guardare dove sono le cose.
//
// La lista kasher del paese (geo_descriptions.kosher_list_pdf) viaggia
// con loro: e' country-scoped apposta, cosi' esce in ogni citta' di quel
// paese e non solo sulla pagina del paese.
import React, { useState, useEffect } from 'react';
import { t } from './i18n';
import { api, countryCode, citySlugify, hotelSearchUrl, flightsUrl, carRentalUrl, AFFILIATE_ENABLED } from './api';

const COLORS = {
  primary: '#1a4d8f', text: '#1f2937', muted: '#6b7280', border: '#e5e7eb', bg: '#f7f8fa',
};

// Sta sopra la mappa, quindi lo stacco va SOTTO: con marginTop si
// incollava alla descrizione del posto e restava appiccicato alla mappa.
const card = {
  background: 'white', border: `1px solid ${COLORS.border}`, borderRadius: 12,
  padding: 14, marginBottom: 16,
};
const head = {
  fontSize: 11, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase',
  letterSpacing: 0.4, marginBottom: 10,
};
const linkRow = {
  display: 'inline-flex', alignItems: 'center', gap: 8, padding: '8px 12px', borderRadius: 8,
  textDecoration: 'none', fontSize: 14, fontWeight: 600, color: COLORS.primary,
  background: COLORS.bg, border: `1px solid ${COLORS.border}`,
};

export default function PlanYourTrip({ filters }) {
  const { country, state, city } = filters || {};

  const [kosherList, setKosherList] = useState('');
  useEffect(() => {
    let active = true;
    setKosherList('');
    if (country) {
      api.geoDescription({ country })
        .then((d) => { if (active) setKosherList(d?.kosher_list_pdf || ''); })
        .catch(() => {});
    }
    return () => { active = false; };
  }, [country]);

  const cc = country ? countryCode(country) : null;
  const citySlug = city ? citySlugify(city) : null;
  const loc = city || state || country;
  const dest = city
    ? `${city}${country ? `, ${country}` : ''}`
    : state ? `${state}${country ? `, ${country}` : ''}` : country;

  const links = [];
  if (kosherList) links.push({ key: 'kosherlist', href: kosherList, label: `📋 ${t('Kosher list')}${country ? ` (${country})` : ''}`, ext: true });
  // Una sola porta d'ingresso alla citta': la Guida, che elenca tutto e ha in
  // cima il bottone «Plan Shabbat in <citta'>». Un secondo link al piano
  // sarebbe lo stesso posto due volte.
  if (cc && citySlug) {
    links.push({ key: 'guide', href: `/${cc}/${citySlug}`, label: `📖 ${t('Jewish guide to')} ${city}` });
  }
  if (AFFILIATE_ENABLED) {
    if (dest) links.push({ key: 'hotels', href: hotelSearchUrl(dest), label: `🏨 ${t('Hotels')}${loc ? ` ${t('in')} ${loc}` : ''}`, ext: true });
    links.push({ key: 'flights', href: flightsUrl(city ? `${city}${country ? `, ${country}` : ''}` : undefined), label: city ? `✈️ ${t('Flights to')} ${city}` : `✈️ ${t('Flights')}`, ext: true });
    links.push({ key: 'cars', href: carRentalUrl(city || undefined), label: city ? `🚗 ${t('Rent a car in')} ${city}` : `🚗 ${t('Rent a car')}`, ext: true });
  }

  if (!links.length) return null;

  return (
    <div style={card}>
      <div style={head}>{t('Plan your trip')}</div>
      {/* In riga che va a capo, non incolonnati: qui sotto c'e' tutta la
          larghezza dei risultati, non i 250 pixel del rail. */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {links.map((l) => (
          <a
            key={l.key}
            href={l.href}
            {...(l.ext ? { target: '_blank', rel: 'noreferrer sponsored' } : {})}
            style={linkRow}
          >
            {l.label}
          </a>
        ))}
      </div>
    </div>
  );
}
